import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const ThreeRow = ({ label = '', subLabel = '', subSubLabel = '' }) => (
    <div className="fm-select-row fm-select-row__three">
        <p className="fm-select-row__label">{label}</p>
        <p className="fm-select-row__sub-label">{subLabel}</p>
        <p className="fm-select-row__sub-sub-label">{subSubLabel}</p>
    </div>
);

ThreeRow.propTypes = {
    label: PropTypes.string,
    subLabel: PropTypes.string,
    subSubLabel: PropTypes.string,
};

export default ThreeRow;
